var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 8C8.8 8.99411 7.99411 9.8 7 9.8H4C3.00589 9.8 2.2 8.99411 2.2 8C2.2 7.00589 3.00589 6.2 4 6.2H5.42692C5.65775 5.74269 5.97379 5.33574 6.35418 5H4C2.34315 5 1 6.34315 1 8C1 9.65685 2.34315 11 4 11H7C8.65685 11 10 9.65685 10 8H8.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 8C7.2 7.00589 8.00589 6.2 9 6.2H12C12.9941 6.2 13.8 7.00589 13.8 8C13.8 8.99411 12.9941 9.8 12 9.8H10.5731C10.3423 10.2573 10.0262 10.6643 9.64582 11H12C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5H9C7.34315 5 6 6.34315 6 8H7.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.41bd075a2e9b1ffb626fb2ede9ff2fe7.svg";
export { ForwardRef as ReactComponent };